if (!customElements.get('diana-card-media')) {
  customElements.define('diana-card-media', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.secondary = this.querySelector('[data-dual-secondary]');
      this.card = this.closest('[data-pc-product-card]');
      if (!this.secondary || !this.card) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.pointer = window.matchMedia('(any-hover:hover) and (any-pointer:fine)');
      this.hovered = false;
      this.keyboard = false;
      this.card.addEventListener('pointerenter', event => {
        if (!this.pointer.matches || !['mouse', 'pen'].includes(event.pointerType)) return;
        this.hovered = true;
        this.loadAlternate();
        this.updateActive();
      }, options);
      this.card.addEventListener('pointerleave', () => { this.hovered = false; this.updateActive(); }, options);
      this.card.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') { this.hovered = false; this.keyboard = false; this.updateActive(); }
      }, options);
      this.card.addEventListener('focusin', event => {
        this.keyboard = event.target.matches(':focus-visible');
        if (this.keyboard) this.loadAlternate();
        this.updateActive();
      }, options);
      this.card.addEventListener('focusout', () => { this.keyboard = false; this.updateActive(); }, options);
      this.onPointerChange = () => {
        if (!this.pointer.matches) { this.hovered = false; this.updateActive(); }
      };
      this.pointer.addEventListener('change', this.onPointerChange);
      // Only desktop-capable devices prewarm near-view secondary assets.
      if (this.pointer.matches && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.loadAlternate(); this.observer.disconnect(); }
        }, {rootMargin: '180px'});
        this.observer.observe(this);
      }
    }
    updateActive() { this.toggleAttribute('data-dual-active', this.hovered || this.keyboard); }
    loadAlternate() {
      if (this.requested) return;
      const image = this.secondary;
      if (!image?.dataset.src) return;
      this.requested = true;
      const loaded = async () => {
        if (!image.naturalWidth) return;
        try { await image.decode(); } catch { /* Some browsers reject decode after a valid load. */ }
        if (this.isConnected && image.naturalWidth) this.setAttribute('data-dual-ready', '');
      };
      image.addEventListener('load', loaded, {once: true, signal: this.controller.signal});
      image.addEventListener('error', () => this.removeAttribute('data-dual-ready'), {once: true, signal: this.controller.signal});
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      if (image.complete && image.naturalWidth) loaded();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.pointer?.removeEventListener('change', this.onPointerChange);
      this.controller = null;
      this.requested = false;
      this.removeAttribute('data-dual-active');
    }
  });
}
